/* Farmacias LF · pie de página, barra inferior móvil y páginas (sucursales, farmacia autorizada,
   ayuda y contacto, libro de reclamos, seguimiento de pedido).
   Lo incluyen varias secciones (lf-footer, lf-tabbar, lf-sucursales, lf-legal, lf-contacto, lf-libro-reclamos,
   lf-seguimiento): el guard de abajo evita que se inicialice dos veces.

   1. Acordeones del pie (solo < 750 px; en escritorio las columnas quedan abiertas).
   2. Interruptores simples: <button data-lf-toggle="id" aria-expanded="false"> muestra/oculta #id.
   3. Pestaña «Categorías»: si el header no tiene #lf-menu-drawer, navega a data-lf-fallback.
   4. Pestaña «Carro»: abre <cart-drawer> (si no existe, sigue el enlace a /cart) y mantiene el contador al día.
   5. Botones «Copiar» (data-lf-copy="texto").
   6. Formularios form[data-lf-validate]: validación con mensajes en español (campo .lf-fm__err indicado en
      aria-describedby), RUT chileno (input[data-lf-rut]) y estado «Enviando…» (botón [data-lf-sending]).
   7. Libro de reclamos (form[data-lf-folio]): folio LF-AAAAMMDD-XXXX en el campo oculto [data-lf-folio-in];
      se guarda en sessionStorage y se muestra en [data-lf-folio-box] cuando Shopify confirma el envío.
   8. Consulta de pedido por WhatsApp (form[data-lf-wa-pedido]): arma el mensaje con [pedido].
   9. Documentos ([data-lf-doc], snippet lf-documento-marco): índice «En esta página» con los h2 visibles del cuerpo
      (si hay menos de 2, usa los h3 o los h4 de los textos antiguos), id automáticos, sección activa al desplazarse
      y altura de la columna fija según lo que tape el encabezado pegajoso.
*/
(() => {
  if (window.LFPaginas) return;

  document.documentElement.classList.add('lf-js');
  const desk = window.matchMedia('(min-width: 750px)');

  /* 1. Acordeones del pie ------------------------------------------------- */
  const setAcc = (col, open) => {
    col.classList.toggle('lf-is-open', open);
    const btn = col.querySelector('.lf-ft__tg');
    if (btn) btn.setAttribute('aria-expanded', String(open));
  };

  const syncAcc = (scope) => {
    (scope || document).querySelectorAll('[data-lf-acc]').forEach((col) => {
      const btn = col.querySelector('.lf-ft__tg');
      if (!btn) return;
      if (desk.matches) {
        btn.setAttribute('tabindex', '-1');
        btn.setAttribute('aria-expanded', 'true');
      } else {
        btn.removeAttribute('tabindex');
        btn.setAttribute('aria-expanded', String(col.classList.contains('lf-is-open')));
      }
    });
  };

  if (desk.addEventListener) desk.addEventListener('change', () => syncAcc());
  else if (desk.addListener) desk.addListener(() => syncAcc());
  syncAcc();

  /* 3. «Categorías» sin menú móvil: ir a la lista de colecciones.
        Fase de captura para adelantarse a lf-capsula.js (que escucha data-lf-open). */
  document.addEventListener(
    'click',
    (e) => {
      const btn = e.target.closest('[data-lf-open][data-lf-fallback]');
      if (!btn || document.getElementById(btn.dataset.lfOpen)) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      window.location.href = btn.dataset.lfFallback;
    },
    true
  );

  document.addEventListener('click', (e) => {
    /* 1. Acordeón del pie */
    const tg = e.target.closest('.lf-ft__tg');
    if (tg) {
      if (desk.matches) return;
      const col = tg.closest('[data-lf-acc]');
      if (col) setAcc(col, !col.classList.contains('lf-is-open'));
      return;
    }

    /* 2. Interruptores */
    const toggler = e.target.closest('[data-lf-toggle]');
    if (toggler) {
      const target = document.getElementById(toggler.dataset.lfToggle);
      if (!target) return;
      const open = toggler.getAttribute('aria-expanded') !== 'true';
      toggler.setAttribute('aria-expanded', String(open));
      target.hidden = !open;
      return;
    }

    /* 4. Carro */
    const cartLink = e.target.closest('[data-lf-cart-open]');
    if (cartLink) {
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        e.preventDefault();
        drawer.open(cartLink);
      }
      return;
    }

    /* 5. Copiar */
    const copyBtn = e.target.closest('[data-lf-copy]');
    if (copyBtn) {
      const text = copyBtn.dataset.lfCopy || '';
      const status = copyBtn.dataset.lfCopyStatus ? document.getElementById(copyBtn.dataset.lfCopyStatus) : null;
      const done = () => {
        copyBtn.classList.add('lf-is-done');
        if (status) status.textContent = status.dataset.okText || 'Copiado';
        setTimeout(() => {
          copyBtn.classList.remove('lf-is-done');
          if (status) status.textContent = '';
        }, 2500);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(done).catch(() => {});
      }
    }
  });

  /* 4. Contador del carro ------------------------------------------------- */
  const renderCount = (count) => {
    document.querySelectorAll('[data-lf-cart-count]').forEach((el) => {
      el.textContent = count > 99 ? '99+' : String(count);
      el.hidden = count === 0;
    });
    document.querySelectorAll('[data-lf-cart-open]').forEach((link) => {
      const label = link.dataset.lfCartLabel || 'Carro';
      link.setAttribute('aria-label', `${label}: ${count} ${count === 1 ? 'producto' : 'productos'}`);
    });
  };

  const refreshCount = () => {
    const base = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
    fetch(`${base}.js`, { headers: { Accept: 'application/json' } })
      .then((r) => (r.ok ? r.json() : null))
      .then((cart) => {
        if (cart && typeof cart.item_count === 'number') renderCount(cart.item_count);
      })
      .catch(() => {});
  };

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      const data = event && event.cartData;
      if (data && typeof data.item_count === 'number') renderCount(data.item_count);
      else refreshCount();
    });
  }

  /* Al volver con «Atrás» la página puede venir de la caché del navegador */
  window.addEventListener('pageshow', (e) => {
    if (e.persisted) refreshCount();
  });

  /* 6. Validación de formularios en español ------------------------------- */
  const MSG = {
    required: 'Completa este campo.',
    select: 'Elige una opción.',
    email: 'Revisa el correo: debe tener el formato nombre@correo.cl.',
    rutFormat: 'Escribe tu RUT con dígito verificador, por ejemplo 12.345.678-5.',
    rut: 'Revisa el RUT: el dígito verificador no coincide.',
  };

  const cleanRut = (v) => String(v || '').replace(/[^0-9kK]/g, '').toUpperCase();
  const rutDv = (body) => {
    let sum = 0;
    let mul = 2;
    for (let i = body.length - 1; i >= 0; i -= 1) {
      sum += parseInt(body[i], 10) * mul;
      mul = mul === 7 ? 2 : mul + 1;
    }
    const r = 11 - (sum % 11);
    if (r === 11) return '0';
    if (r === 10) return 'K';
    return String(r);
  };
  const formatRut = (v) => {
    const c = cleanRut(v);
    if (c.length < 2) return String(v || '').trim();
    return `${c.slice(0, -1).replace(/\B(?=(\d{3})+(?!\d))/g, '.')}-${c.slice(-1)}`;
  };
  const rutError = (v) => {
    const c = cleanRut(v);
    if (!/^\d{6,8}[\dK]$/.test(c)) return MSG.rutFormat;
    return rutDv(c.slice(0, -1)) === c.slice(-1) ? '' : MSG.rut;
  };

  const radiosOf = (el) => (el.form ? [...el.form.querySelectorAll('input[type="radio"]')].filter((r) => r.name === el.name) : [el]);

  const fieldMsg = (el) => {
    if (el.type === 'radio') {
      const group = radiosOf(el);
      return group.some((r) => r.required) && !group.some((r) => r.checked) ? MSG.select : '';
    }
    const v = (el.value || '').trim();
    if (el.required && !v) return el.tagName === 'SELECT' ? MSG.select : MSG.required;
    if (v && el.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) return MSG.email;
    if (v && el.hasAttribute('data-lf-rut')) return rutError(v);
    return '';
  };

  const errBox = (el) => {
    const host = el.type === 'radio' ? el.closest('fieldset') || el : el;
    const ids = (host.getAttribute('aria-describedby') || '').split(/\s+/);
    for (const id of ids) {
      const n = id ? document.getElementById(id) : null;
      if (n && n.classList.contains('lf-fm__err')) return n;
    }
    return null;
  };

  const showErr = (el, msg) => {
    const targets = el.type === 'radio' ? radiosOf(el) : [el];
    targets.forEach((t) => {
      if (msg) t.setAttribute('aria-invalid', 'true');
      else t.removeAttribute('aria-invalid');
    });
    const box = errBox(el);
    if (!box) return;
    box.textContent = msg;
    box.hidden = !msg;
  };

  const makeFolio = () => {
    const d = new Date();
    const p2 = (n) => String(n).padStart(2, '0');
    const abc = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
    const bytes = new Uint8Array(4);
    if (window.crypto && window.crypto.getRandomValues) window.crypto.getRandomValues(bytes);
    else bytes.forEach((_, i) => { bytes[i] = Math.floor(Math.random() * 256); });
    let code = '';
    bytes.forEach((b) => { code += abc[b % abc.length]; });
    return `LF-${d.getFullYear()}${p2(d.getMonth() + 1)}${p2(d.getDate())}-${code}`;
  };

  const resetSending = (form) => {
    const btn = form.querySelector('[data-lf-sending]');
    if (!btn || !btn.classList.contains('lf-is-sending')) return;
    btn.classList.remove('lf-is-sending');
    btn.removeAttribute('aria-disabled');
    const label = btn.querySelector('span');
    if (label && btn.dataset.lfLabel) label.textContent = btn.dataset.lfLabel;
    delete form.dataset.lfSent;
  };

  const initForm = (form) => {
    if (form.dataset.lfReady) return;
    form.dataset.lfReady = '1';
    form.setAttribute('novalidate', '');

    const folioIn = form.querySelector('[data-lf-folio-in]');
    if (folioIn && !folioIn.value) folioIn.value = makeFolio();

    form.addEventListener('submit', (e) => {
      if (form.dataset.lfSent) {
        e.preventDefault();
        return;
      }
      const seen = new Set();
      let first = null;
      form.querySelectorAll('input, select, textarea').forEach((el) => {
        if (el.disabled || ['hidden', 'submit', 'button'].includes(el.type)) return;
        if (el.type === 'radio') {
          if (seen.has(el.name)) return;
          seen.add(el.name);
        }
        const msg = fieldMsg(el);
        showErr(el, msg);
        if (msg && !first) first = el.type === 'radio' ? radiosOf(el)[0] : el;
      });
      if (first) {
        e.preventDefault();
        first.focus();
        return;
      }
      form.querySelectorAll('[data-lf-rut]').forEach((el) => { el.value = formatRut(el.value); });
      if (folioIn) {
        if (!folioIn.value) folioIn.value = makeFolio();
        try { sessionStorage.setItem('lf-folio', folioIn.value); } catch (er) { /* sin almacenamiento */ }
      }
      form.dataset.lfSent = '1';
      const btn = form.querySelector('[data-lf-sending]');
      if (btn) {
        const label = btn.querySelector('span');
        if (label) {
          btn.dataset.lfLabel = label.textContent;
          label.textContent = btn.dataset.lfSending;
        }
        btn.classList.add('lf-is-sending');
        btn.setAttribute('aria-disabled', 'true');
      }
    });

    const recheck = (e) => {
      const el = e.target;
      if (!el || !el.matches || !el.matches('input, select, textarea')) return;
      const invalid = el.type === 'radio' ? radiosOf(el).some((r) => r.getAttribute('aria-invalid') === 'true') : el.getAttribute('aria-invalid') === 'true';
      if (invalid) showErr(el, fieldMsg(el));
    };
    form.addEventListener('input', recheck);
    form.addEventListener('change', recheck);
    form.addEventListener('focusout', (e) => {
      const el = e.target;
      if (el && el.hasAttribute && el.hasAttribute('data-lf-rut') && el.value.trim()) {
        el.value = formatRut(el.value);
        showErr(el, fieldMsg(el));
      }
    });
  };

  /* 7. Folio del libro de reclamos tras el envío ---------------------------- */
  const showFolio = (scope) => {
    (scope || document).querySelectorAll('[data-lf-folio-box]').forEach((box) => {
      let folio = '';
      try { folio = sessionStorage.getItem('lf-folio') || ''; } catch (er) { /* sin almacenamiento */ }
      if (!folio) return;
      const out = box.querySelector('[data-lf-folio-out]');
      if (out) out.textContent = folio;
      const copy = box.querySelector('[data-lf-copy]');
      if (copy) copy.dataset.lfCopy = folio;
      box.hidden = false;
    });
  };

  const initForms = (scope) => {
    (scope || document).querySelectorAll('form[data-lf-validate]').forEach(initForm);
    showFolio(scope);
  };
  initForms();

  /* 8. Consulta de pedido por WhatsApp -------------------------------------- */
  document.addEventListener('submit', (e) => {
    const form = e.target && e.target.closest ? e.target.closest('form[data-lf-wa-pedido]') : null;
    if (!form) return;
    e.preventDefault();
    const input = form.querySelector('input[name="text"]');
    const num = input ? input.value.trim() : '';
    const base = form.dataset.lfWaMsg || '';
    const msg = num ? base.replace('[pedido]', num) : base.replace(/\s*\[pedido\]/, '');
    const url = `${form.action}?text=${encodeURIComponent(msg)}`;
    const win = window.open(url, '_blank');
    if (win) win.opener = null;
    else window.location.href = url;
  });

  /* 9. Documentos: índice «En esta página» ------------------------------- */
  const slugify = (t) =>
    String(t || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 60) || 'seccion';

  const docTop = () => {
    const hd = document.querySelector('.lf-section-header');
    const bottom = hd ? Math.max(0, hd.getBoundingClientRect().bottom) : 0;
    return Math.round(bottom);
  };

  const initDoc = (root) => {
    if (root.dataset.lfDocReady) return;
    root.dataset.lfDocReady = '1';

    /* Chips de documentos (celular): dejar a la vista el documento actual */
    const actual = root.querySelector('.lf-doc__docs [aria-current="page"]');
    const chips = actual ? actual.closest('ul') : null;
    if (chips && chips.scrollWidth > chips.clientWidth) {
      chips.scrollLeft = Math.max(0, actual.offsetLeft - chips.offsetLeft - 16);
    }

    const body = root.querySelector('[data-lf-doc-body]');
    const lists = root.querySelectorAll('[data-lf-doc-list]');
    if (!body || !lists.length) return;

    const visible = (h) => h.getClientRects().length > 0 && (h.textContent || '').trim() !== '';
    let heads = [];
    for (const sel of ['h2', 'h3', 'h4']) {
      heads = [...body.querySelectorAll(sel)].filter(visible);
      if (heads.length >= 2) break;
    }
    if (heads.length < 2) return;

    const used = new Set();
    const items = heads.map((h) => {
      let id = h.id || slugify(h.textContent);
      const base = id;
      let n = 2;
      while (used.has(id) || (document.getElementById(id) && document.getElementById(id) !== h)) {
        id = `${base}-${n}`;
        n += 1;
      }
      used.add(id);
      h.id = id;
      return { id, text: h.textContent.replace(/\s+/g, ' ').trim(), el: h };
    });

    lists.forEach((list) => {
      list.textContent = '';
      items.forEach((it) => {
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.href = `#${it.id}`;
        a.textContent = it.text;
        a.dataset.lfDocLink = it.id;
        li.appendChild(a);
        list.appendChild(li);
      });
    });
    root.querySelectorAll('[data-lf-doc-toc], [data-lf-doc-mtoc]').forEach((n) => { n.hidden = false; });

    /* En el celular, el desplegable se cierra al elegir una sección */
    root.querySelectorAll('[data-lf-doc-mtoc]').forEach((det) => {
      det.addEventListener('click', (e) => {
        if (e.target.closest('a')) det.open = false;
      });
    });

    const links = [...root.querySelectorAll('[data-lf-doc-link]')];
    let current = '';
    let ticking = false;
    const update = () => {
      ticking = false;
      const top = docTop();
      root.style.setProperty('--lf-doc-top', `${top + 16}px`);
      /* Una sección cuenta como activa desde que su título pasa bajo el encabezado (o bajo su margen de ancla) */
      const margen = parseFloat(getComputedStyle(items[0].el).scrollMarginTop) || 0;
      const line = Math.max(top + 32, margen + 8);
      let active = items[0].id;
      items.forEach((it) => {
        if (it.el.getBoundingClientRect().top <= line) active = it.id;
      });
      if (active === current) return;
      current = active;
      links.forEach((a) => {
        const on = a.dataset.lfDocLink === active;
        a.classList.toggle('lf-is-active', on);
        if (on) a.setAttribute('aria-current', 'true');
        else a.removeAttribute('aria-current');
      });
    };
    let after = null;
    const onScroll = () => {
      /* El encabezado pegajoso se esconde o aparece con una transición: se vuelve a medir al terminar */
      clearTimeout(after);
      after = setTimeout(update, 320);
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    const hd = document.querySelector('.lf-section-header');
    if (hd) hd.addEventListener('transitionend', onScroll);
    update();
  };

  const initDocs = (scope) => {
    (scope || document).querySelectorAll('[data-lf-doc]').forEach(initDoc);
  };
  initDocs();

  /* Al volver con «Atrás», el botón no debe quedar en «Enviando…» */
  window.addEventListener('pageshow', (e) => {
    if (e.persisted) document.querySelectorAll('form[data-lf-validate]').forEach(resetSending);
  });

  /* Editor de temas: al recargar una sección, volver a aplicar el estado del acordeón y los formularios */
  document.addEventListener('shopify:section:load', (e) => {
    syncAcc(e.target);
    initForms(e.target);
    initDocs(e.target);
  });

  window.LFPaginas = { refreshCount, renderCount, syncAcc, formatRut, rutError, makeFolio };
})();
